<div class="container">
  <span class="eyebrow">{{ 'prog.eyebrow' | traduire }}</span>
  <h2>{{ 'prog.titre' | traduire }}</h2>

  <p *ngIf="chargementEnCours" style="color: var(--stone);">{{ 'prog.chargement' | traduire }}</p>
  <p *ngIf="messageErreur" style="color: var(--coral);">{{ messageErreur }}</p>

  <div class="filtres-programme" *ngIf="!chargementEnCours">
    <div class="calendrier">
      <div class="calendrier-entete">
        <button type="button" (click)="moisPrecedent()">‹</button>
        <span>{{ nomMois }}</span>
        <button type="button" (click)="moisSuivant()">›</button>
      </div>
      <div class="calendrier-jours-semaine">
        <span *ngFor="let l of lettresJours">{{ l }}</span>
      </div>
      <div class="calendrier-grille">
        <button type="button" class="case-jour" *ngFor="let c of joursDuCalendrier"
                [class.vide]="!c.jour"
                [class.actif]="c.date === dateSelectionnee"
                [class.a-des-evenements]="c.aDesEvenements"
                [disabled]="!c.jour"
                (click)="choisirDate(c.date)">
          {{ c.jour }}
          <span class="pastille" *ngIf="c.aDesEvenements"></span>
        </button>
      </div>
    </div>

    <div class="filtres-lateraux">
      <label>{{ 'prog.filtrer' | traduire }}</label>
      <select [(ngModel)]="categorieSelectionnee">
        <option value="">{{ 'prog.toutes' | traduire }}</option>
        <option *ngFor="let cat of categories" [value]="cat">{{ cat }}</option>
      </select>

      <p class="filtre-actif" *ngIf="dateSelectionnee">
        📅 {{ dateSelectionnee }}
        <button type="button" (click)="choisirDate(null)">✕</button>
      </p>

      <button type="button" class="btn-effacer-filtres"
              *ngIf="dateSelectionnee || categorieSelectionnee"
              (click)="effacerFiltres()">{{ 'prog.reinitialiser' | traduire }}</button>

      <p class="resultat-compte">{{ evenementsFiltres.length }} {{ 'prog.resultats' | traduire }}</p>
    </div>
  </div>

  <div class="ticket-list">
    <div class="ticket-card" *ngFor="let evenement of evenementsFiltres" (click)="ouvrirDetails(evenement)">
      <div class="ticket-media">
        <video *ngIf="estVideo(evenement.imageUrl)" [src]="evenement.imageUrl" muted loop autoplay playsinline></video>
        <img *ngIf="!estVideo(evenement.imageUrl)" [src]="evenement.imageUrl || 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=600'" [alt]="titreLangue(evenement)">
        <span class="event-tag">{{ evenement.categorie }}</span>
      </div>
      <div class="ticket-seam"><i></i><i></i></div>
      <div class="ticket-body">
        <h3>{{ titreLangue(evenement) }}</h3>
        <p class="lieu">📍 {{ evenement.lieu }} <span *ngIf="evenement.dateEvent">— {{ evenement.dateEvent }}</span></p>
        <p class="desc">{{ descriptionLangue(evenement) }}</p>
        <div class="ticket-foot">
          <div class="barcode"></div>
          <span class="prix">{{ evenement.prix }} TND</span>
          <a class="btn-gold" style="padding:9px 18px;" href="https://gate-pass.tn/" target="_blank" rel="noopener" (click)="$event.stopPropagation()">{{ 'prog.reserver' | traduire }}</a>
        </div>
      </div>
    </div>

    <p *ngIf="!chargementEnCours && evenementsFiltres.length === 0" style="color: var(--stone);">
      {{ 'prog.aucun' | traduire }}
    </p>
  </div>
</div>

<!-- ================= FENETRE DE DETAILS ================= -->
<div class="modal-overlay" *ngIf="evenementSelectionne" (click)="fermerDetails()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="fermerDetails()">✕</button>

    <div class="modal-media" *ngIf="evenementSelectionne.youtubeId; else photoSeule">
      <iframe
        [src]="urlVideoSecurisee(evenementSelectionne.youtubeId)"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>
    <ng-template #photoSeule>
      <video *ngIf="estVideo(evenementSelectionne.imageUrl)" [src]="evenementSelectionne.imageUrl" muted loop autoplay playsinline controls></video>
      <img *ngIf="!estVideo(evenementSelectionne.imageUrl)" [src]="evenementSelectionne.imageUrl || 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=900'" [alt]="titreLangue(evenementSelectionne)">
    </ng-template>

    <div class="modal-contenu">
      <span class="event-tag">{{ evenementSelectionne.categorie }}</span>
      <h3>{{ titreLangue(evenementSelectionne) }}</h3>
      <p class="lieu">📍 {{ evenementSelectionne.lieu }} <span *ngIf="evenementSelectionne.dateEvent">— {{ evenementSelectionne.dateEvent }}</span></p>
      <p class="desc">{{ descriptionLangue(evenementSelectionne) }}</p>

      <div class="modal-prix">
        <span class="prix">{{ evenementSelectionne.prix }} TND</span>
        <a class="btn-gold" href="https://gate-pass.tn/" target="_blank" rel="noopener">{{ 'prog.reserver.place' | traduire }}</a>
      </div>

      <div class="modal-carte">
        <h4>{{ 'prog.localisation' | traduire }}</h4>
        <iframe
          [src]="urlCarteSecurisee(evenementSelectionne.lieu)"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
    </div>
  </div>
</div>
